export const getDateNDaysFromNow = (days: number) => {
  // Get current date/time in UTC, then convert to UK time (Europe/London)
  const now = new Date();
  // Get UTC time components
  const utcYear = now.getUTCFullYear();
  const utcMonth = now.getUTCMonth();
  const utcDate = now.getUTCDate();
  const utcHours = now.getUTCHours();
  const utcMinutes = now.getUTCMinutes();
  const utcSeconds = now.getUTCSeconds();
  // Create a date in UTC
  const utcDateObj = new Date(
    Date.UTC(utcYear, utcMonth, utcDate, utcHours, utcMinutes, utcSeconds),
  );
  // Get UK offset for current date (BST/GMT)
  // UK time zone is Europe/London, but Date does not support IANA zones natively, so we use locale string
  const ukDateString = utcDateObj.toLocaleString('en-GB', { timeZone: 'Europe/London' });
  const [day, month, year] = ukDateString.split(',')[0].split('/');
  // Create a new Date object in UK time
  const ukDate = new Date(`${year}-${month}-${day}T00:00:00`);
  ukDate.setDate(ukDate.getDate() + days);
  const resultYear = ukDate.getFullYear();
  const resultMonth = String(ukDate.getMonth() + 1).padStart(2, '0');
  const resultDay = String(ukDate.getDate()).padStart(2, '0');
  return `${resultYear}-${resultMonth}-${resultDay}`;
};
